import React, {PureComponent} from "react"

import OptionPicker, {Option} from "../../OptionPicker"
import DefaultMessage from "../DefaultMessage"
import OptionContainerProps from "../sharedProps"
import NotReady from "./NotReady"
import PeopleList from "./PeopleList"
import SetUpSSO from "./SetUpSSO"
import {isReadyToInvite, resetSSO, isDefaultSSO} from "../../../helpers"

interface Props extends OptionContainerProps {}

// We want to merge these SSO settings changes but don't want to enable them
// until we have updated copy.  When the work is finalised this flag and
// DefaultMessage will be removed, and optionData streamlined
const displaySSOOnboarding = false

class Invite extends PureComponent<Props> {
  optionData: Option[] = [
    {
      selectionId: 1,
      title: "setup_tenant.steps.invite.options.ready.title",
      description: "setup_tenant.steps.invite.options.ready.description",
      actionRequiredForStepCompletion: true,
      component: <PeopleList setIsStepCompletable={this.props.setIsStepCompletable} />
    },
    displaySSOOnboarding
      ? {
        selectionId: 2,
        title: "setup_tenant.steps.invite.options.setUpSSO.title",
        description: "setup_tenant.steps.invite.options.setUpSSO.description",
        actionRequiredForStepCompletion: true,
        component: <SetUpSSO setIsStepCompletable={this.props.setIsStepCompletable} />
      }
      : {
        selectionId: 2,
        title: "setup_tenant.steps.invite.options.notReady.title",
        description: "setup_tenant.steps.invite.options.notReady.description",
        actionRequiredForStepCompletion: true,
        component: <DefaultMessage message="setup_tenant.steps.invite.options.notReady.defaultMessage" />
      }
  ]

  render() {
    const {tenantOnboarding, setIsStepCompletable, existingSelectionId, handleOptionChange} = this.props

    if (!isReadyToInvite(tenantOnboarding.assignedSteps)) {
      return <NotReady tenantOnboardingSteps={tenantOnboarding.assignedSteps} />
    }

    return (
      <OptionPicker
        setIsStepCompletable={setIsStepCompletable}
        existingSelectionId={existingSelectionId}
        handleOptionChange={handleOptionChange}
        areStepSettingsDefault={() => isDefaultSSO(existingSelectionId === 2)}
        options={this.optionData}
        resetToDefault={resetSSO} />
    )
  }
}

export default Invite
